export enum SpaceType {
  EXTERIOR = "EXTERIOR",
  EXTERIOR_COVERED = "EXTERIOR_COVERED",

  EXTERIOR_BACK = "EXTERIOR_BACK",
  EXTERIOR_COVERED_BACK = "EXTERIOR_COVERED_BACK",

  TRANSITION = "TRANSITION",
  CIRCULATION = "CIRCULATION",

  GATHERING = "GATHERING",
  DINING = "DINING",
  KITCHEN = "KITCHEN",
  LIVING = "LIVING",

  CONTEMPLATIVE = "CONTEMPLATIVE",
  BEDROOM = "BEDROOM",

  BATHROOM = "BATHROOM",

  UTILITY = "UTILITY",
  STORAGE = "STORAGE",

  GENERAL = "GENERAL",

  UNCLASSIFIED = "UNCLASSIFIED",
}
